import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-router-dom";
import { Button, Stack, styled, TextField } from "@mui/material";
import { useTheme } from "../../../../../components/Theme";

const StyledSearchForm = styled(Stack)`
  flex-direction: row;
  gap: 1em;
  margin: 1em;
`;


// Created a style for button from material ui using light/dark theme
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#ffffff' : '#095D7E',
  color: theme.palette.mode === 'dark' ? '#000000' : '#ffffff',
  padding: '1rem',
  width: '8rem ',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? '#f1f1f1' : '#095D7E',
  },

}));



const SearchForm = ({
  defaultSearch,
}) => {
  const [search, setSearch] = useState(defaultSearch ?? "");
  const searchFieldRef = useRef(null);
  const disabled = !search.trim().length;

  const { darkMode, toggleModes } = useTheme();

  useEffect(() => {
    if (searchFieldRef.current) {
      searchFieldRef.current.focus();
    }
  }, [searchFieldRef]);

  return (
    <StyledSearchForm
      component={Form}
      method="GET"
      width={{
        xs: "100%",
        md: "80%",
        lg: "70%",
      }}
    >
      <TextField
        name="search"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        inputRef={searchFieldRef}
        placeholder={"Search by First/Last Name or Email"}
        fullWidth

      />
      <StyledButton
        name="button"
        type="submit"
      >
        Search
      </StyledButton>
    </StyledSearchForm>
  );
};

export default SearchForm;